<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>
      <div style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      ">
          {{ $t('settings.notes.emailNotifications') }}
      </div>

      <div class="xColumn">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.newEmployeeCreated') }}
          </strong>
          <br/>

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">
                      {{ $t('settings.notes.emailAddress') }}
                  </th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForNewEmployeeNotifications"
                  :key="'emailsForNewEmployeeNotifications' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>

                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>
      <!-- v-on:click="saveEmailForNewEmployeeNotification" -->

      <div class="xColumn">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.contractEnded') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">
                      {{ $t('settings.notes.emailAddress') }}
                  </th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForEmployeeFiredNotifications"
                  :key="'emailsForEmployeeFiredNotifications' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>

                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>

      <div class="xColumn">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.monthlyClosingFinished') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">
                      {{ $t('settings.notes.emailAddress') }}
                  </th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForMonthlyFinancialStatementClosed"
                  :key="'emailsForMonthlyFinancialStatementClosed' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>

                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>

      <div class="xColumn">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.monthlyClosingReopened') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">
                      {{ $t('settings.notes.emailAddress') }}
                  </th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForMonthlyFinancialStatementReopened"
                  :key="'emailsForMonthlyFinancialStatementReopened' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>
                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>

      <div class="xColumn mt-5" v-if="[2,3,4,5,6].includes(externalSoftware)">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.sotecExportFailed') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">
                      {{ $t('settings.notes.emailAddress') }}
                  </th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForSotecProblem"
                  :key="'emailsForSotecProblem' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>
                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>

      <div class="xColumn mt-5" v-if="[2,3,4,5,6].includes(externalSoftware)">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.sotecPrecheck') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">{{ $t('settings.notes.emailAddress') }}</th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForSotecPrecheck"
                  :key="'emailsForSotecPrecheck' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>
                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>

      <div class="xColumn mt-5" v-if="[2,3,4,5,6].includes(externalSoftware)">
          <strong style="font-size: 16px">
              {{ $t('settings.notes.sotecSpecialExport') }}
          </strong>
          <br />

          <table class="table table-striped table-borderless" style="margin-top: 7px">
              <tr>
                  <th class="documentsTh">{{ $t('settings.notes.emailAddress') }}</th>
                  <th class="documentsTh" style="text-align: center">
                      {{ $t('settings.notes.delete') }}
                  </th>
              </tr>

              <tr
                  v-for="listing in emailsForSotecExportChecklists"
                  :key="'emailsForSotecExportChecklists' + listing.id"
              >
                  <td class="documentsTd">
                      <strong>{{ listing.email }}</strong>
                  </td>
                  <td class="documentsTd" style="text-align: center">
                      <button
                          v-tooltip="$t('settings.notes.deleteEntryTooltip')"
                          class="icon-button"
                          @click="deleteEmailForNewEmployeeNotification(listing.id)"
                      >
                          <i class="fas fa-trash"></i>
                      </button>
                  </td>
              </tr>
          </table>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "NotificationOverview",
  data() {
    return {
      emailsForNewEmployeeNotifications: [],
      emailsForEmployeeFiredNotifications: [],
      emailsForMonthlyFinancialStatementClosed: [],
      emailsForMonthlyFinancialStatementReopened: [],
      emailsForSotecProblem: [],
      emailsForSotecPrecheck: [],
      emailsForSotecExportChecklists: [],
    };
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters([
      "companyId",
      "isSuperUser",
      "externalServicesMap",
      "companySettings",
      "selectedStores",
      "externalSoftware",
    ]),
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format("YYYY-MM-DD");
    },
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
        state.buttons.push({
            type: "block",
            icon: "fa-refresh",
            click: () => {
                view.refresh();
            },
            tooltip: view.$t('settings.notes.reloadData'),
        });

        state.buttons.push({
            type: "block green",
            icon: "fa-plus",
            click: () => {
                view.openNewEntryPopup();
            },
            tooltip: view.$t('settings.notes.addNewEmail'),
        });
      return state;
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.emailsForNewEmployeeNotifications = [];
      view.emailsForEmployeeFiredNotifications = [];
      view.emailsForMonthlyFinancialStatementClosed = [];
      view.emailsForMonthlyFinancialStatementReopened = [];
      view.emailsForSotecProblem = [];
      view.emailsForSotecPrecheck = [];
      view.emailsForSotecExportChecklists = [];
      this.loadListForNewEmployeeNotification();
    },

    loadListForNewEmployeeNotification: function () {
      let view = this;
      let url = "/api/sec/notification/email/list";
      const params = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
      })
        .then((response) => {
          view.emailsForNewEmployeeNotifications = [];
          view.emailsForEmployeeFiredNotifications = [];
          view.emailsForMonthlyFinancialStatementClosed = [];
          view.emailsForMonthlyFinancialStatementReopened = [];
          view.emailsForSotecProblem = [];
          view.emailsForSotecPrecheck = [];
          view.emailsForSotecExportChecklists = [];
          for (let i in response.data.data) {
            let o = response.data.data[i];
            if (o.notificationEventId == 1) {
              view.emailsForNewEmployeeNotifications.push(o);
            } else if (o.notificationEventId == 2) {
              view.emailsForMonthlyFinancialStatementClosed.push(o);
            } else if (o.notificationEventId == 3) {
              view.emailsForMonthlyFinancialStatementReopened.push(o);
            } else if (o.notificationEventId == 4) {
              view.emailsForSotecProblem.push(o);
            }else if(o.notificationEventId == 5) {
              view.emailsForEmployeeFiredNotifications.push(o);
            }else if(o.notificationEventId == 6) {
              view.emailsForSotecPrecheck.push(o);
            }else if(o.notificationEventId == 7) {
              view.emailsForSotecExportChecklists.push(o);
            }
          }
        })
        .catch(function (error) {});
    },
    saveNewEmailListing: function (notificationEventId, newEmailForNotification) {
      let view = this;
      let url = "/api/sec/notification/email/list";
      const params = {
        companyId: this.$store.state.companyId,
      };
      let payload = {
        email: newEmailForNotification,
        notificationEventId: notificationEventId,
      };
      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
        data: payload,
      })
          .then((response) => {
              view.$helpers.success(
                  view.$t('settings.notes.infoTitle'),
                  view.$t('settings.notes.emailAdded')
              );
              view.loadListForNewEmployeeNotification();
          })
          .catch(function (error) {
              view.$helpers.error(
                  view.$t('settings.notes.infoTitle'),
                  view.$t('settings.notes.errorAddingEmail')
              );
          });
    },
    deleteEmailForNewEmployeeNotification: function (id) {
      let view = this;
      let url = "/api/sec/notification/email/newemployeeList";
      const params = {
        companyId: this.$store.state.companyId,
      };
      let payload = {
        id: id,
      };
      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
        data: payload,
      })
          .then((response) => {
              view.$helpers.success(
                  view.$t('settings.notes.infoTitle'),
                  view.$t('settings.notes.emailDeleted')
              );
              view.loadListForNewEmployeeNotification();
          })
          .catch(function (error) {
              view.$helpers.error(
                  view.$t('settings.notes.infoTitle'),
                  view.$t('settings.notes.errorDeletingEmail')
              );
          });
    },

    openNewEntryPopup() {
      let view = this;
      let notificationItems = [];
      let selectedItem = {};
      let selectedItems = [];

      let notificationTypes = [];
        notificationTypes.push({
            id: 1,
            label: view.$t('settings.notes.newEmployeeCreated'),
        });
        notificationTypes.push({
            id: 5,
            label: view.$t('settings.notes.contractEnded'),
        });
        notificationTypes.push({
            id: 2,
            label: view.$t('settings.notes.monthlyClosingFinished'),
        });
        notificationTypes.push({
            id: 3,
            label: view.$t('settings.notes.monthlyClosingReopened'),
        });
        notificationTypes.push({
            id: 4,
            label: view.$t('settings.notes.sotecProblem'),
        });
        notificationTypes.push({
            id: 6,
            label: view.$t('settings.notes.sotecPrecheck'),
        });
        notificationTypes.push({
            id: 7,
            label: view.$t('settings.notes.sotecChecklistSpecial'),
        });

      notificationTypes.forEach((t) => {
        t.label_de = t.label;
        t.value = t.id;
        notificationItems.push(t);
        if (1 == t.id) {
          selectedItem = t;
          selectedItems.push(selectedItem);
        }
      });
        let dataEntries = [
            {
                label: view.$t('settings.notes.emailAddressLabel'),
                key: "email",
                hidden: false,
                type: "text",
                value: "",
                length: 128,
                styles: { width: "500px" },
            },
            {
                label: view.$t('settings.notes.notificationType'),
                key: "notification_type",
                hidden: false,
                type: "dropdownsearch",
                value: null,
                selectMultiple: false,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: "",
                    items: notificationItems,
                    selectMultiple: false,
                    selectedItems: selectedItems,
                    selectedItem: selectedItem,
                    onceSelected: function ($event, item, searchbar) {},
                    styleLight: true,
                    placeholder: view.$t('settings.notes.selectTypePlaceholder'),
                },
            },
            { flexDivider: true, styles: { "margin-bottom": "23px" } },
        ];

      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        componentState: {
          entries: dataEntries,
          selectCallback: function (x) {
            view.saveNewEmailListing(x.notification_type, x.email);
          },
          errorCheck: {
            'email': (entries) => {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!entries.hasOwnProperty('email') || entries.email == "") {
                    return {
                        key: 'email',
                        label: view.$t('settings.notes.emailAddress'),
                        type: 'error',
                        text: view.$t('settings.notes.errorEmailRequired')
                    }
                } else if (!emailRegex.test(entries.email.trim())) {
                    return {
                        key: 'email',
                        label: view.$t('settings.notes.emailAddress'),
                        type: 'error',
                        text: view.$t('settings.notes.errorEmailInvalid')
                    }
                } else {
                    return null
                }
            }
          }
        },
          header: view.$t('settings.notes.enterEmailAddress'),
        remainAfterSelect: false,
        expanded: true,
        centered: true,
      });
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.xColumn {
  width: calc(33% - 30px);
  text-align: left;
  float: left;
  margin-left: 15px;
  margin-right: 15px;
  padding: 5px;
}
</style>
